import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Form, Input, message } from 'antd';
import { graphql, compose } from 'react-apollo';

import MUTATION from '../graphql/mutations/newRetainerClientAssignmentDiscussionTopicCommentMutation.graphql';

const FormItem = Form.Item;
const { TextArea } = Input;

class NewRetainerClientAssignmentDiscussionTopicCommentForm extends Component {
  state = {
    submittingForm: false,
  };

  componentDidUpdate(prevProps) {
    const { form, discussionTopicId } = this.props;
    if (discussionTopicId !== prevProps.discussionTopicId) {
      form.resetFields();
    }
  }

  handleSubmit = (event) => {
    event.preventDefault();
    this.setState({
      submittingForm: true,
    });

    const { form, mutate, discussionTopicId, refetchQuery } = this.props;
    form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        mutate({ variables: { discussionTopicId, ...values } })
          .then(() => {
            this.setState({
              submittingForm: false,
            });
            form.resetFields();
            refetchQuery();
          })
          .catch((err1) => {
            this.setState({
              submittingForm: false,
            });
            console.log(err1);
            message.error(err1.message);
          });
      } else {
        this.setState({
          submittingForm: false,
        });
      }
    });
  };

  render() {
    const { submittingForm } = this.state;
    const { form } = this.props;
    const { getFieldDecorator } = form;

    return (
      <Form onSubmit={this.handleSubmit}>
        <FormItem>
          {getFieldDecorator('comment', {
            rules: [{ required: true, message: 'Field is required!' }],
          })(<TextArea disabled={submittingForm} autosize={{ minRows: 2, maxRows: 4 }} />)}
        </FormItem>
        <FormItem>
          <Button type="primary" htmlType="submit" loading={submittingForm}>
            Post comment
          </Button>
        </FormItem>
      </Form>
    );
  }
}

NewRetainerClientAssignmentDiscussionTopicCommentForm.propTypes = {
  discussionTopicId: PropTypes.number.isRequired,
  form: PropTypes.shape({
    getFieldDecorator: PropTypes.func,
    validateFieldsAndScroll: PropTypes.func,
    resetFields: PropTypes.func,
  }).isRequired,
  mutate: PropTypes.func.isRequired,
  refetchQuery: PropTypes.func.isRequired,
};

export default compose(
  graphql(MUTATION),
  Form.create(),
)(NewRetainerClientAssignmentDiscussionTopicCommentForm);



// WEBPACK FOOTER //
// ./src/forms/NewRetainerClientAssignmentDiscussionTopicCommentForm.jsx